import { Masonry } from '@leagueplatform/masonry';
import { MASONRY } from 'common/constants';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { useParams, useSearchParams } from 'react-router-dom';
import { MasonryPageLayout } from 'components/masonry-page-layout/masonry-page-layout.component';
import { CancelAppointmentModalHost } from 'components/modals/cancel-appointment-modal-host.component';

export const AppointmentDetails = () => {
  usePageViewAnalytics({ screen_name: 'Appointment Details' });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_APPOINTMENT_DETAILS' }));
  const { appointmentId, systemId } = useParams<{
    appointmentId: string;
    systemId: string;
  }>();

  const [searchParams] = useSearchParams();
  const clinicId = searchParams.get('clinicId');

  if (!appointmentId || !systemId) {
    return null;
  }

  return (
    <MasonryPageLayout showBackButton>
      <Masonry
        rootNodeId={MASONRY.ROOT_NODE_APPOINTMENT_DETAILS_PAGE}
        initialQueryParams={{
          appointmentId,
          systemId,
          ...(clinicId ? { clinicId } : {}),
        }}
      />
      <CancelAppointmentModalHost />
    </MasonryPageLayout>
  );
};
